import { Directive, HostBinding } from '@angular/core';

// FullStory keys privacy controls off CSS classes. Amplitude uses one class for Session Replay and
// one data attribute for autocapture, while Hotjar uses its own data attribute.
@Directive({
  selector: '[data-recorders-suppress]',
  standalone: true
})
export class RecordersSuppressDirective {
  @HostBinding('attr.data-hj-suppress') readonly hotjarSuppress = '';
  @HostBinding('attr.data-amp-mask') readonly amplitudeAutocaptureMask = '';
  @HostBinding('class.amp-mask') readonly amplitudeSessionReplayMask = true;
  @HostBinding('class.fs-mask') readonly fullStoryMask = true;
}
